import { Card, CardContent, CardSubTitle, CardTitle } from "@artists/uikit"
import { Skeleton } from "@mui/material"

import { Favorite } from "../../../../../@shared"

export const Loader = () => (
	<Card>
		<Skeleton
			animation='wave'
			sx={{
				pt: "100%",
				borderRadius: "0",
				transform: "none",
				"&:empty:before": { content: "''" },
			}}
		/>

		<CardContent>
			<CardTitle width='90%'>
				<Skeleton />
			</CardTitle>
			<CardSubTitle width='40%'>
				<Skeleton />
			</CardSubTitle>
		</CardContent>

		<Favorite disabled sx={{ m: 1, mt: -1 }} />
	</Card>
)
